export function cartItemMetadataFromObject(metadataObject) {
    return Object.keys(metadataObject).map(function (key) { return ({
        key: key,
        value: metadataObject[key],
    }); });
}
